export default __webpack_public_path__ + "static/media/mon_256.4fb0fae1.png";